document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('slider-component');

  sliders.forEach((slider, index) => {
    const scrollContainer = slider.querySelector('.slider') || slider.querySelector('.scroll-area');
    if (!scrollContainer) {
      console.warn(`No scroll container found for slider #${index}`);
      return;
    }

    const slide = scrollContainer.querySelector('.slide') || scrollContainer.children[0];
    if (!slide) return;

    const slideWidth = slide.offsetWidth + parseInt(getComputedStyle(slide).marginRight || 0);
    const prevBtn = slider.querySelector('button[name="previous"]');
    const nextBtn = slider.querySelector('button[name="next"]');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: slideWidth, behavior: 'smooth' });
      });
    }
  });
});
